// WEB-2263: reordering for the assignment materials picker.
document.addEventListener('alpine:init', () => {
  Alpine.data('materialSort', () => ({
    dragIndex: null,

    // Rows have their own x-data, so $el in a handler is the button, not the
    // list. Only init() sees the component root.
    container: null,

    init() {
      this.container = this.$el
    },

    start(event, index) {
      this.dragIndex = index
      // Firefox refuses to start a drag without payload.
      if (event.dataTransfer) {
        event.dataTransfer.effectAllowed = 'move'
        event.dataTransfer.setData('text/plain', String(index))
      }
    },

    drop(event, index) {
      if (this.dragIndex === null || this.dragIndex === index) return
      this.reposition(this.dragIndex, index)
      this.dragIndex = null
    },

    move(index, delta) {
      const target = index + delta
      if (target < 0 || target >= this.rows().length) return
      this.reposition(index, target)
      // Keep focus on the pressed control so repeats move the same row.
      this.$nextTick(() => {
        const rows = this.rows()
        const button = rows[target]?.querySelector(
          delta < 0
            ? '[aria-label^="Move"][aria-label*="up"]'
            : '[aria-label^="Move"][aria-label*="down"]'
        )
        if (button) button.focus()
      })
    },

    rows() {
      return Array.from(this.container.querySelectorAll('[data-material-id]'))
    },

    reposition(from, to) {
      const rows = this.rows()
      const moving = rows[from]
      if (!moving) return
      if (from < to) {
        rows[to].after(moving)
      } else {
        rows[to].before(moving)
      }
      this.commit()
    },

    commit() {
      this.container.dispatchEvent(
        new CustomEvent('reorder', { bubbles: true })
      )
    },
  }))
})
